<div class="main-box">
    <div class="left-sub-box">
        <div class="left-sub-container">
            <div *ngIf="hasPostHubAccess" class="post-nav-container" routerLink="/admin/social-hub/post-hub" >
                <div style="width: 20px; height: 20px; left: 0px;position: absolute">
                    <img src="assets/post-icon.svg">
                </div>
                <!-- <div style="width: 5%; height: 30px; left: 245px; position: absolute; transform-origin: 0 0; border: 3px #386AF6 solid"></div> -->
                <div class="left-item-text">Posts Hub
                </div>
            </div>
            <div style="width: 246.13px; height: 0px; border: 0.50px #ECECEC solid"></div>
            <div style="width: 172.92px; height: 19.03px; position: relative">
                <div *ngIf="hasCompetitionZoneAccess" style="width: 3%; height: 30px; left: 245px; position: absolute; transform-origin: 0 0; border: 3px #386AF6 solid"></div>
                <div class="left-item-text"> Competitions Hub</div>
                <img src="assets/competition-icon.svg">
            </div>
            <div style="width: 246.13px; height: 0px; border: 0.50px #ECECEC solid"></div>
        </div>
    </div>




    <div class="right-sub-box">
        <div *ngIf="hasCompetitionZoneAccess"
            style="width: 923.87px; justify-content: space-between; align-items: flex-start; gap: 12px; display: inline-flex">
            <a href="/admin/social-hub/competition-zone" class="fillter-button "
                [ngStyle]="sortingType =='OPEN' && {'background': '#E3ECFB'}">
                <div class="fillter-button-text">Open Competitions</div>
            </a>
            <a  href="/admin/social-hub/competition-zone/CLOSED" class="fillter-button"
                [ngStyle]="sortingType =='CLOSED' && {'background': '#E3ECFB'}">
                <div class="fillter-button-text">Closed Competitions</div>
            </a>
            <a href="/admin/social-hub/competition-zone/SCHEDULED" class="fillter-button"
                [ngStyle]="sortingType =='SCHEDULED' && {'background': '#E3ECFB'}">
                <div class="fillter-button-text">Scheduled</div>
            </a>
            <a href="/admin/social-hub/competition-zone/DRAFT" class="fillter-button" style="margin-right: 60px;"
                [ngStyle]="sortingType =='DRAFT' && {'background': '#E3ECFB'}">
                <div class="fillter-button-text">Drafts</div>
            </a>

            <button class="fillter-button" style="background:#386AF6;">
                <div
                    style="color: #FFF; font-size: 12px; font-family: Montserrat; font-weight: 500; letter-spacing: 0.24px; word-wrap: break-word" routerLink="/admin/social-hub/competition-zone/competition/create-competition/{{'new'}}/edit">
                    <img src="assets/plus-icon.svg">
                    Create New Competition
                </div>
            </button>


        </div>
        <div *ngIf="!hasCompetitionZoneAccess" class="no-access-message" fxLayout="column" fxLayoutAlign="center center">
            <h3>Access Restricted</h3>
            <p>You don't have permission to access the Competition Zone.</p>
        </div>
        <div *ngIf="hasCompetitionZoneAccess && sortingType =='OPEN'">
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div fxFlex="20%" class="text-center">
                    <span class="table-header-text">Title</span>
                </div>
                <div fxFlex="20%" class="text-center">
                    <span class="table-header-text">Start Date</span>
                    <img [src]="sortIconStartTimeSrc" class="arrow-icon" (click)="sortAccToStartTime()">

                </div>
                <div fxFlex="20%" class="text-center">
                    <span class="table-header-text">End Date</span>
                    <img [src]="sortIconEndTimeSrc" class="arrow-icon" (click)="sortAccToEndTime()">
                </div>
                <div fxFlex="40%" class="text-center">
                    <span class="table-header-text"> Entries received </span>
                </div>

            </div>

            <div *ngFor="let competition of competitions" class="table-item">
                <div fxLayout="row" fxLayoutAlign="space-between center table-text-item">
                    <div fxFlex="20%" class="text-center table-text-item" style="padding-left: 5px;">
                        {{competition?.title?.en}}
                    </div>
                    <div fxFlex="20%" class="text-center table-text-item">
                        {{competition?.start_time | dateTransform: 'timestamp' }}
                    </div>
                    <div fxFlex="20%" class="text-center table-text-item">
                        {{competition?.end_time | dateTransform: 'timestamp' }}
                    </div>
                    <div fxFlex="40%" class="text-center table-text-item">
                        {{competition?.submission_count}}

                    </div>
                    <img src="assets/angle.svg" style="cursor: pointer;" routerLink="/admin/social-hub/competition-zone/OPEN/{{competition?.competition_uuid}}/false">
                </div>
            </div>
        </div>

        <div *ngIf="hasCompetitionZoneAccess && sortingType =='CLOSED'">
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div fxFlex="20%" class="text-center">
                    <span class="table-header-text">Title</span>
                </div>
                <div fxFlex="20%" class="text-center">
                    <span class="table-header-text">Start Date</span>
                    <img [src]="sortIconStartTimeSrc" class="arrow-icon" (click)="sortAccToStartTime()">

                </div>
                <div fxFlex="20%" class="text-center">
                    <span class="table-header-text">End Date</span>
                    <img [src]="sortIconEndTimeSrc" class="arrow-icon" (click)="sortAccToEndTime()">
                </div>
                <div fxFlex="20%" class="text-center">
                    <span class="table-header-text"> Entries received </span>
                </div>
                <div fxFlex="20%" class="text-center">
                    <span class="table-header-text"> Status </span>
                </div>

            </div>
            <div *ngFor="let competition of competitions" class="table-item">
                <div fxLayout="row" fxLayoutAlign="space-between center table-text-item">
                    <div fxFlex="20%" class="text-center table-text-item" style="padding-left: 5px;">
                        {{competition?.title?.en}}
                    </div>
                    <div fxFlex="20%" class="text-center table-text-item">
                        {{competition?.start_time | dateTransform: 'timestamp' }}
                    </div>
                    <div fxFlex="20%" class="text-center table-text-item">
                        {{competition?.end_time | dateTransform: 'timestamp' }}
                    </div>
                    <div fxFlex="20%" class="text-center table-text-item">
                        {{competition?.submission_count}}

                    </div>
                    <div fxFlex="20%" class="text-center table-text-item">
                        <span *ngIf="competition?.result_declared" style="color: #00BA34;">Winners Announced</span>
                        <span *ngIf="!competition?.result_declared" style="color: #EB5757;">Announce Winners</span>

                    </div>
                    <img src="assets/angle.svg" style="cursor: pointer;" routerLink="/admin//social-hub/competition-zone/CLOSED/{{competition?.competition_uuid}}/{{competition?.result_declared}}">
                </div>
            </div>
        </div>



        <div *ngIf="hasCompetitionZoneAccess && sortingType =='SCHEDULED'">
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div fxFlex="20%" class="text-center">
                    <span class="table-header-text">Competition</span>
                </div>
 
                <div fxFlex="20%" class="text-center">
                    <span class="table-header-text">Scheduled for</span>
                    <img [src]="sortIconStartTimeSrc" class="arrow-icon" (click)="sortAccToStartTime()">
                </div>

                <div fxFlex="20%" class="text-center">
                    <span class="table-header-text"> </span>
                </div>

            </div>
            <div *ngFor="let competition of competitions" class="table-item">
                <div fxLayout="row" fxLayoutAlign="space-between center table-text-item">
                    <div fxFlex="20%" class="text-center table-text-item" style="padding-left: 5px;">
                        {{competition?.title?.en}}
                    </div>

                    <div fxFlex="20%" class="text-center table-text-item">
                        {{competition?.start_time | dateTransform: 'timestamp' }}
                    </div>
                    <div fxFlex="20%" class="text-center table-text-item"
                        style="display: flex; flex-direction: row-reverse;">
                        <img src="assets/angle.svg" style="cursor: pointer;" routerLink="/admin/social-hub/competition-zone/SCHEDULED/{{competition?.competition_uuid}}/false">
                        <img src="assets/delete-icon.svg" style="margin-right: 7px; cursor: pointer;" (click)="deleteCompetition(competition?.title?.en,competition?.competition_uuid)">
                        <button type="button" style="background: white; border-radius: 8px; border: 0.50px #386AF6 solid; margin-right: 7px; display: none;" (click)="openReschedulePopUp(competition?.title?.en, competition?.start_time, competition?.competition_uuid)">
                            <span style="color: #386AF6; font-size: 12px; font-family: Montserrat; font-weight: 500; letter-spacing: 0.02px; word-wrap: break-word; margin-right: 6px;">Reschedule</span>
                            <img src="assets/without-rount-angle.svg">
                        </button>
                    </div>
                </div>
            </div>

        </div>

        <div *ngIf="hasCompetitionZoneAccess && sortingType =='DRAFT'">
            <div fxLayout="row" fxLayoutAlign="space-between center">
                <div fxFlex="20%" class="text-center">
                    <span class="table-header-text">Competition</span>
                </div>
                <div fxFlex="20%" class="text-center">
                </div>
                <div fxFlex="20%" class="text-center">
                </div>
                <div fxFlex="20%" class="text-center">
                    <span class="table-header-text"> </span>
                </div>
                <div fxFlex="20%" class="text-center">
                    <span class="table-header-text"> </span>
                </div>

            </div>
            <div *ngFor="let competition of competitions" class="table-item">
                <div fxLayout="row" fxLayoutAlign="space-between center table-text-item">
                    <div fxFlex="20%" class="text-center table-text-item" style="padding-left: 5px;">
                        {{competition?.title?.en}}
                    </div>
                    <div fxFlex="20%" class="text-center table-text-item">
                   </div>
                    <div fxFlex="20%" class="text-center table-text-item">
                    </div>
                    <div fxFlex="60%" class="text-center table-text-item"
                        style="display: flex; flex-direction: row-reverse;">
                        <img src="assets/angle.svg" style="cursor: pointer;" routerLink="/social-hub/competition-zone/DRAFT/{{competition?.competition_uuid}}/false">
                        <img src="assets/delete-icon.svg" style="margin-right: 7px; cursor: pointer; display: none;">
                    </div>
                </div>
            </div>
        </div>
        
    </div>